import React, { useEffect } from 'react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security, useOktaAuth } from '@okta/okta-react';
import { BrowserRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './css/app.scss';

import Header from './components/header';
import Sidebar from './components/sidebar/sidebar';
import Loading from './components/loading-indicator/authLoading';
import Footer from './components/footer';

import Inventory from './views/transfer/inventory';
import Warehouse from './views/transfer/warehouse';
import ImageDownload from './views/transfer/imagedownload';

import CustomerNotifies from './views/report/customerNotifies';

import config from './config';

const oktaAuth = new OktaAuth(config.oidc);

// add close action to all snackbars
const notistackRef = React.createRef();
const onClickDismiss = key => () => { 
    notistackRef.current.closeSnackbar(key);
}

const RequireAuth = ({ children }) => {
  const { authState } = useOktaAuth();
  const location = useLocation();

  // While authState is undefined (loading), render nothing or a spinner
  if (!authState) {
    return null; // or <Loading />
  }

  // If not authenticated, redirect to login and render nothing
  if (!authState.isAuthenticated) {
    const originalUri = location.pathname + location.search + location.hash;
    oktaAuth.setOriginalUri(toRelativeUrl(originalUri || '/', window.location.origin));
    oktaAuth.signInWithRedirect();
    return null; // Prevent rendering children while redirecting
  }

  // Authenticated: render children
  return children;
};

const RoutableApp = () => {
  const navigate = useNavigate();

  const triggerLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
  };
  
  return (
    <div>
      <Security
        oktaAuth={oktaAuth}
        onAuthRequired={triggerLogin}
        restoreOriginalUri={restoreOriginalUri}>
          <Loading />
          <Sidebar />
          
          <div id="body-content">
            <Header />
            
            <Routes>
              <Route path="/login/callback" element={<LoginCallback />}/>
              <Route path="/" element={<RequireAuth><Inventory /></RequireAuth>} />
              <Route path="/transfer/inventory" element={<RequireAuth><Inventory /></RequireAuth>}/>
              <Route path="/transfer/warehouse" element={<RequireAuth><Warehouse /></RequireAuth>}/>
              <Route path="/transfer/imagedownload" element={<RequireAuth><ImageDownload /></RequireAuth>}/>
              <Route path="/report/customer-notifies" element={<RequireAuth><CustomerNotifies /></RequireAuth>}/>
            </Routes>
            
            <ToastContainer 
              autoClose={5000} 
              hideProgressBar
              transition={Slide} />

            <Footer />
          </div>
      </Security>
    </div>
  ) 
}

export default function App() {
  return (
    <div id="app">
      <Router>
        <RoutableApp />
      </Router>
    </div>
  );
}
